export const TOKEN_KEY = 'devplat-token'
export const USER_ID_KEY = 'devplat-uid'
export const USER_NAME_KEY = 'devplat-uname'
export const RUNTIME_KEY = 'devplat-runtime'
export const OAUTH_STATE_KEY = 'devplat-oauth-state'
/** Hydra 回跳会丢掉 URL 上的 from，登录前写入，换码后再读。 */
export const OAUTH_FROM_KEY = 'devplat-oauth-from'

type Store = {
  getItem: (key: string) => string | null
  setItem: (key: string, value: string) => void
  removeItem: (key: string) => void
}

function memoryStore(): Store {
  const map = new Map<string, string>()
  return {
    getItem: (key) => map.get(key) ?? null,
    setItem: (key, value) => {
      map.set(key, value)
    },
    removeItem: (key) => {
      map.delete(key)
    },
  }
}

function browserStore(): Store {
  if (typeof localStorage === 'undefined') return memoryStore()
  return localStorage
}

const store = browserStore()

export const storage = {
  get(key: string): string | null {
    return store.getItem(key)
  },
  set(key: string, value: string) {
    store.setItem(key, value)
  },
  remove(key: string) {
    store.removeItem(key)
  },
}
